import { escape } from "lodash";
import type {
  ActivityObject,
  ObjectWithContent,
} from "../../@types/activities.ts";

// The HTML preview of a collapsed sticky post; a questionnaire title is plain text
export default function closedStickyContent(
  object: ActivityObject,
): string | undefined {
  if (object.type === "appointment") return undefined;
  if (object.type === "questionnaire") return escape(object.title);

  return (object as ObjectWithContent).content;
}
